<template>
  <div class="viewer-total-container">
    <div class="left-container" :style="leftStyle">
      <slot name="left"></slot>
    </div>
    <div class="right-container" :style="rightStyle">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DoubleColumnsView',
  props: {
    // 两列等高布局 一边定宽 另一边自适应
    fixedPart: {
      type: String,
      default: 'right',
      validator: function (value) {
        return ['left', 'right'].some(item => value);
      }
    },
    fixedPartWidth: {
      type: Number,
      default: 400
    }
  },
  computed: {
    leftStyle() {
      let style = {};
      if (this.fixedPart == 'left') {
        style.width = this.fixedPartWidth + 'px';
        style.minWidth = this.fixedPartWidth + 'px';
      } else {
        style.flex = 1;
      }
      return style;
    },
    rightStyle() {
      let style = {};
      if (this.fixedPart == 'right') {
        style.width = this.fixedPartWidth + 'px';
        style.minWidth = this.fixedPartWidth + 'px';
      } else {
        style.flex = 1;
      }
      return style;
    }
  }
}
</script>

<style scoped lang="scss">
.viewer-total-container {
  display: flex;
  align-items: stretch;

  .left-container {

  }

  .right-continer {

  }
}
</style>



// WEBPACK FOOTER //
// src/components/container/doubleColumnsView.vue